import React from 'react'
import './styles.css'
import {connect} from "react-redux";
import * as actionCreator from "../../../store/Action/index";
import {Card, CardBody, CardHeader} from 'reactstrap';
import {MDBDataTable, MDBModal, MDBModalBody, MDBModalHeader} from 'mdbreact'
import {Button as SementicBtn} from 'semantic-ui-react'
import {Icon, Spin} from "antd";
import "../../../commonBtnStyle.css";
import * as Validator from "../../../util/Validator";
import $ from "jquery";
import * as common from "../../../const/Common/CommonFunc";
import are_you_sure_icon from "../../../assets/img/sweet/question.svg";
import swal from "sweetalert";

import {geocodeByAddress, getLatLng} from "react-places-autocomplete";
import Cookies from "js-cookie";
import axiosTags from "../../../axios/axios_tag";
import Update from "./Update/Update";
import apiConfig from "../../../axios/axios_api_services";
import QRCode from "qrcode";
import Download from "../../../components/Button/DownloadbleButton";
import {withRouter} from "react-router-dom";
import * as routeConstants from "../../../const/route/Route";

class App extends React.Component {

  state = {
    branchData: {
      name:
        {
          value: '',
          valid: false
        },
      address:
        {
          value: '',
          valid: false
        },
      subscription:
        {
          value: '',
          valid: false
        },
      valid: false
    },
    formValid: false,
    isMap: false,
    isSpin: false,

    branch_list: [],
    branchObj:null,

    // location details
    location: '',
    location_:'',
    latLng: null, qrIamge: null,selectBranch: '',modalType:'UPDATE'
  };
  changeSpinner = (condition) => {
    this.setState({
      isSpin: condition
    })
  };

  handleChangeSubscription = e => {
    let value = e.target.value;
    const formData = {
      ...this.state.branchData
    };
    formData["subscription"].value = value;
    formData["subscription"].valid = true;

    this.setState({
      branchData: formData
    });
  };

  handleChange = (name, length) => event => {
    let value = event.target.value;
    const valid = Validator.textFieldValidator(value, length);

    const formData = {
      ...this.state.branchData
    };
    formData[name].value = value;
    formData[name].valid = valid;

    this.setState({
      branchData: formData
    });
  };
  clearFeilds = () => {
    const formData = {
      ...this.state.branchData
    };
    formData.name.value = '';
    formData.address.value = '';
    formData.subscription.value = '';

    this.setState({
      branchData: formData,
      location: ''
    });
  };

  getAllBranch = () => {

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    this.changeSpinner(true);
    axiosTags.get(apiConfig.CORPORATE_BRANCH(this.props.usr_obj.corporateId), {headers: headers})
      .then(response => {
        let length = 0;
        if (response.data.success) {
          length = response.data.branchList.length;
          this.setState({
            branch_list: response.data.branchList
          })
        } else {
          this.setState({
            branch_list: []
          })
        }
        //  dashboard single type
        this.props.addTagsDashboardSingle("branchCount",length);
        //  --------
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllBranch()
        }
      })
      .finally(fin => {
        this.changeSpinner(false);
      });
  };

  handleChange_ = location => {
    this.setState({location});
  };
  handleSelect_ = location => {
    this.setState({location});
  };

  addressHandler_ = (location) => {
    this.setState({location});
  };

  deleteBranch = (id,name) => {
    swal({
      title:"Do you want to delete this branch? First please enter \""+name+"\"",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      content: "input",
    })
      .then((value) => {
        if(value === name){
          this.deleteBranch_(id)
        }else{
          common.warningAlert("Can't delete branch", 1)
        }
      });

  };

  deleteBranch_ = (id) => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axiosTags.delete(apiConfig.CORPORATE_BRANCH_DELETE(id), {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert("Branch details successfully deleted", 0);
          this.clearFeilds();
          this.getAllBranch();
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.deleteBranch_(id)
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  updateBranch = (obj) => {
    this.setState({
      modalType:'UPDATE', branchObj:obj, isUpdate: true
    })
  };

  viewLocation = (location) => {
    geocodeByAddress(location)
      .then(results => getLatLng(results[0]))
      .then(latLng => this.setState(
        {latLng: latLng, isMap: true, location_: location}
        ))
      .catch(error => common.notifyMessage(error));
  };

  viewMap = () => {
    this.setState({
      isMap: !this.state.isMap,
    })
  };

  componentDidMount() {
    $('input').attr('autocomplete', 'off');
    this.getAllBranch();
  }

  generateQR = (obj) => {

    if(obj.buildings.length === 0){
      swal({
        title:"You need to add buildings and floors of this branch to view the QR code",
        icon: are_you_sure_icon,
        closeOnClickOutside: false,
        buttons: {
          cancel: 'Close',
          dangerMode: {text: "Add building", value: "action", className: "okay-btn"}
        }
      })
        .then((value) => {
          switch (value) {
            case "action":
              this.props.history.push({
                pathname: `/corporate/building/manage`,
                state: `${obj.branchId}`
              });
              break;
            default:
          }
        });
      return;
    }

    this.props.spinnerHandler(true);

      QRCode.toDataURL(`${routeConstants.VISITOR_BRNACH_QR_URL}${obj.branchId}`.toString(),{ scale: 10 })
        .then(url => {
          this.setState({qrIamge: url,selectBranch: obj.name});
        })
        .catch(err => {
          console.error(err)
        })
        .finally(fin => {
          this.props.spinnerHandler(false);
        })
  };
  viewQRCode = (b64Code) => {
    let result = common.getB64ToBlob(b64Code);
    window.open(result, '_blank');
  };
  render() {
    const rows = [];
    if (this.state.branch_list.length !== 0) {
      this.state.branch_list.map((row, index) => {
        rows.push(
          {
            name: row.name,
            address: row.address,
            // location: row.location,
            // subscription: row.subscriptionNumber,
            // viewlocation: <SementicBtn icon='map marker alternate' circular color={"teal"} onClick={e => this.viewLocation(row.location)}/>,
            building_count: row.buildings.length,
            qr_code:<SementicBtn color={"teal"} circular icon='qrcode' onClick={e => this.generateQR(row)}/>,
            action:
              <div>
                <SementicBtn circular icon='edit' onClick={e => this.updateBranch(row)}/>
                <SementicBtn className="cus-btn" circular icon='trash alternate'
                             onClick={e => this.deleteBranch(row.branchId, row.name)}/>
              </div>
          }
        )
      });
    }

    let columns = this.props.table_data.columns;
    let table_data = {columns, rows};

    return (
      <div>
        {/*{*/}
          {/*this.state.isMap ?*/}
            {/*<MapView location={this.state.location_} latLng={this.state.latLng} closeModal={this.viewMap}/> : null*/}
        {/*}*/}
        {
          this.state.isUpdate ?
            <Update modalType={this.state.modalType} refreshData={this.getAllBranch} closeModal={()=>this.setState({isUpdate:false})} data={this.state.branchObj}/> : null
        }
        {
          this.state.qrIamge ?
            <MDBModal isOpen={true} toggle={()=> {}} size="md" side position="top-right" className={"qr-code-branch"}>
              <MDBModalHeader className={"title-location"} toggle={()=>this.setState({qrIamge: null})}>{this.state.selectBranch}</MDBModalHeader>
              <MDBModalBody style={{padding:'0px'}}>
                <img src={this.state.qrIamge} style={{border: "5px solid rgba(255, 0, 0, 0.5)"}}
                     className="image-qr-branch"/>

                <div className={"qr-btn-branch"}>
                  <a className={"view-qr-btn"} onClick={() => this.viewQRCode(this.state.qrIamge)}>View QR
                    Code</a>
                  <a className={"view-qr-btn"} target={"_blank"} href={this.state.qrIamge} download={"QR code_"+this.state.selectBranch+".png"}>Download
                    QR Code</a>
                </div>
              </MDBModalBody>
            </MDBModal>:null
        }
        <div className={"align-right"} style={{marginBottom: '1rem'}}>
          <SementicBtn className="px-5" onClick={()=>this.setState({modalType:'ADD', isUpdate:true})}>Create</SementicBtn>
        </div>

        <Card className={"manage-branch-tbl"}>
          <CardHeader>All Branches
            <Download data={this.state.branch_list} filename={"all-branches.csv"}/>
          </CardHeader>
          <CardBody>
            <Spin spinning={this.state.isSpin} delay={10}
                  indicator={<Icon type="loading" style={{fontSize: 24}} spin/>}>
              <MDBDataTable
                // searching={true}
                // displayEntries={true}
                // entries={8}
                responsive
                responsiveSm
                responsiveMd
                responsiveLg
                responsiveXl
                bordered
                hover
                data={table_data}/>
            </Spin>

          </CardBody>
        </Card>
      </div>
    );
  }

}

const mapStateToProps = (state) => ({
  table_data: state.COPAdminReducer.branchesTable_data,
  // branchData: state.COPAdminReducer.branchData, <-- not use
  // usr obj
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    addBranch: (data) => dispatch(actionCreator.addBranch(data)), //not use
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    // dashboard single value handler
    addTagsDashboardSingle: (type,data) => dispatch(actionCreator.addTagsDashboardSingle(type,data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));
